export const SET_SCROLL_TO_TIME_STAMP = 'checkoutPage/base/SET_SCROLL_TO_TIME_STAMP';
export const SET_IS_DATA_FETCHING = 'checkoutPage/base/SET_IS_DATA_FETCHING';
